module.exports = __webpack_public_path__ + "static/media/Golos_Text_Medium.9210871a.woff";